<template>
  <div>
    <v-file-input
      ref="file"
      v-model="file"
      class="imageFile"
      accept="image/*"
      prepend-icon=""
      hide-input
      @change="uploadFile"
    ></v-file-input>
  </div>
</template>
<script>
import { postMultipart } from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';

export default {
  mixins: [DialogMixin, LoadingMixin],
  props: {
    existingFileId: { type: String },
  },
  data: () => ({
    file: null,
    fileId: 0,
  }),
  methods: {
    async uploadFile() {
      if (!this.file) return;
      if (this.file.type.split('/')[0] != 'image')
        return this.$showAlert(`이미지 파일만 가능합니다.`);
      this.showLoading();

      const tenantKey = this.$route.params.tenantKey;

      const formData = new FormData();
      formData.append('annoId', this.$route.params.annoId);
      formData.append('file', this.file, this.file.name);
      formData.append('existingFileId', this.existingFileId); //기존 파일이 있는 경우 기존 파일의 fileId 넘겨줘야 함

      await postMultipart('api/v1/' + tenantKey + '/cv/image', formData)
        .then(response => {
          let v;
          let data = response.data;

          if (
            data != null &&
            data != undefined &&
            data.hasOwnProperty('fileId')
          ) {
            v = {
              message: '업로드되었습니다.',
              title: '',
              callback: this.uploadCallback,
            };
            this.fileId = data.fileId;
          } else {
            v = {
              message:
                '파일이 정상적으로 업로드 되지 않았습니다.\n다시 한 번 업로드 하시기 바랍니다.',
              title: '',
              callback: '',
            };
          }
          this.hideLoading();
          this.$showAlert(v);
        })
        .catch(error => {
          console.log('FAILURE!!');
          console.log(error);
        });
    },

    uploadCallback() {
      this.hideLoading();
      this.file = null;
      this.$emit('upload', this.fileId);
    },
    open: function() {
      this.$refs.file.$el.querySelector('input[type="file"]').click();
    },
  },
};
</script>
